export interface FaqItem {
  id: number;
  category: string;
  question: string;
  answer: string;
  points: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    category: "형사절차",
    question: "경찰에서 전화가 왔는데 출석 요구를 거부할 수 있나요?",
    answer:
      "수사기관의 출석 요구를 무조건 무시하는 것은 바람직하지 않습니다. 먼저 본인의 신분이 피의자인지 참고인인지, 사건번호와 혐의, 출석을 요구한 수사관을 확인해야 합니다. 일정 조정이 필요하다면 담당 수사관과 협의하고, 피의자라면 조사 전에 사실관계와 예상 질문을 정리하는 것이 좋습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "통화 일시·담당자·사건번호, 출석요구 방식, 피의자 또는 참고인 여부",
  },
  {
    id: 2,
    category: "형사절차",
    question: "고소장이 접수됐는지 확인할 수 있나요?",
    answer:
      "고소 사실은 수사기관의 연락이나 사건조회 등을 통해 확인되는 경우가 있지만, 접수 직후에는 바로 확인되지 않을 수도 있습니다. 고소인이 어느 경찰서나 검찰청에 제출했는지, 사건번호가 부여됐는지에 따라 확인 방법이 달라집니다. 확인되지 않는다는 이유만으로 고소가 없다고 단정해서는 안 됩니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "접수 기관, 사건번호, 고소인과의 최근 연락, 수사기관 발신번호",
  },
  {
    id: 3,
    category: "형사절차",
    question: "경찰 조사 전에 고소장 내용을 볼 수 있나요?",
    answer:
      "피의자는 방어권 행사를 위해 고소장 등 수사서류의 열람·등사를 신청할 수 있으나, 수사 단계와 문서 내용에 따라 전부 또는 일부가 제한될 수 있습니다. 조사 전에 혐의의 핵심을 파악하고 본인이 보유한 자료와 대조하는 것이 중요합니다. 정보공개청구나 변호인을 통한 신청 가능성을 검토할 수 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "죄명, 범행 일시·장소, 열람·등사 결정 범위, 조사 예정일",
  },
  {
    id: 4,
    category: "형사절차",
    question: "경찰 조사에서 변호사가 같이 들어갈 수 있나요?",
    answer:
      "피의자는 원칙적으로 변호인의 조력을 받을 권리가 있고, 변호인은 정당한 사유가 없는 한 피의자신문에 참여할 수 있습니다. 변호인은 부당한 신문 방식에 이의를 제기하고 조사 후 의견을 진술할 수 있습니다. 다만 참여 방식은 형사소송법과 수사 절차에 따라 달라질 수 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "조사 일정, 참여 신청, 사건기록 검토, 진술 방향과 제출자료",
  },
  {
    id: 5,
    category: "형사절차",
    question: "경찰 조사에서 진술을 거부해도 되나요?",
    answer:
      "피의자는 자신에게 불리한 진술을 강요받지 않으며, 개별 질문 또는 전체 진술을 거부할 수 있습니다. 다만 무조건 침묵하는 것이 모든 사건에서 유리한 것은 아닙니다. 객관적 자료와 혐의 내용을 파악한 뒤 진술할 부분과 답변을 유보할 부분을 구분하는 전략이 필요합니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "혐의 내용, 확보된 증거, 기존 진술, 진술거부권 고지 여부",
  },
  {
    id: 6,
    category: "형사절차",
    question: "경찰에서 불송치 결정이 나오면 사건이 완전히 끝난 건가요?",
    answer:
      "경찰의 불송치 결정으로 일단 검찰 송치 없이 종결될 수 있지만, 고소인 등은 법이 정한 절차에 따라 이의신청을 할 수 있습니다. 이의신청이 있으면 사건은 검사에게 송치되어 검사가 기록을 검토해 재수사를 요청하는 경우도 있습니다. 따라서 결정 이유와 이의절차 진행 여부를 확인해야 최종적인 사건 상태를 판단할 수 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "불송치 이유, 결정 통지일, 이의신청 여부, 재수사 요청 여부",
  },
  {
    id: 7,
    category: "형사절차",
    question: "검찰로 송치되면 이후 절차는 어떻게 되나요?",
    answer:
      "경찰이 사건을 검찰로 송치하면 검사는 기록과 증거를 검토하여 기소, 불기소 또는 보완수사 요구·직접 보완수사 여부 등을 판단합니다. 송치가 곧 유죄나 기소를 의미하지는 않습니다. 송치의견, 핵심 증거와 미진한 부분을 확인해 의견서와 자료를 적절한 시점에 제출할 수 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "송치 죄명, 사건번호, 검찰청 배당, 추가 조사 및 의견서 제출 기한",
  },
  {
    id: 8,
    category: "형사절차",
    question: "형사고소를 취하하면 사건이 무조건 끝나나요?",
    answer:
      "고소 취하의 효과는 범죄 유형에 따라 다릅니다. 친고죄는 원칙적으로 적법한 고소 취하가 공소제기에 영향을 주고, 반의사불벌죄는 피해자의 처벌불원 의사가 중요합니다. 그러나 대부분의 범죄는 고소가 취하돼도 수사와 처벌이 계속될 수 있으며, 합의는 양형 사정으로 고려될 수 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "적용 죄명, 친고죄·반의사불벌죄 여부, 처벌불원서 내용과 제출 시점",
  },
  {
    id: 9,
    category: "형사절차",
    question: "피의자와 피고인은 무엇이 다른가요?",
    answer:
      "수사기관에서 범죄 혐의를 받아 수사 대상이 된 사람을 피의자라고 하고, 검사가 공소를 제기해 형사재판을 받는 사람을 피고인이라고 합니다. 두 지위 모두 변호인의 조력을 받을 권리와 진술거부권 등 방어권이 보장되지만, 적용되는 절차와 대응 시점에는 차이가 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "현재 수사·재판 단계, 사건번호, 공소장 송달 여부, 예정된 기일",
  },
  {
    id: 10,
    category: "형사절차",
    question: "구속영장이 청구되면 바로 구속되나요?",
    answer:
      "검사가 구속영장을 청구했다고 바로 구속되는 것은 아닙니다. 법원은 구속 전 피의자심문을 통해 범죄혐의에 대한 소명정도와 도주나 증거인멸 우려, 구속의 필요성과 상당성 등 구속사유를 심사합니다. 구속사유와 관련하여 주거·직업·가족관계, 수사 협조와 증거 확보 상태 등을 객관적 자료로 설명할 필요가 있습니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "영장청구 죄명, 심문기일, 주거·직업 자료, 피해회복과 수사협조 자료",
  },
  {
    id: 11,
    category: "형사절차",
    question: "형사재판에서 집행유예를 받으면 전과가 남나요?",
    answer:
      "집행유예는 유죄판결이므로 범죄경력자료 등에 기록됩니다. 다만 집행유예 기간을 무사히 경과하면 형 선고의 효력이 법률에 따라 달라질 수 있고, 기록의 보존·조회 범위는 목적과 관계 법령에 따라 다릅니다. 취업·자격 제한 여부도 해당 분야 법령을 별도로 확인해야 합니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "확정 죄명과 형, 집행유예 기간, 취업·자격 관련 개별 법령",
  },
  {
    id: 12,
    category: "형사절차",
    question: "형사 합의서는 어떻게 작성해야 하나요?",
    answer:
      "합의서에는 당사자, 사건, 합의금 지급 여부와 방식, 피해 회복 내용, 처벌 의사 등을 명확히 적는 것이 좋습니다. 처벌불원 의사가 필요한 사건이라면 그 뜻이 분명하게 드러나야 합니다. 과도한 접촉이나 압박은 2차 피해 또는 별도 분쟁으로 이어질 수 있어 전달 방식에도 주의해야 합니다. 형사사건은 초기 진술이 이후 절차에 큰 영향을 줄 수 있습니다. 사실과 다른 추측성 진술을 피하고, 사건별 적용 법률과 최신 판례는 자료를 토대로 개별 검토해야 합니다.",
    points: "정확한 사건번호, 지급일·방법, 처벌불원 문구, 신분 확인과 제출처",
  },
  {
    id: 13,
    category: "성범죄",
    question: "강제추행은 신체접촉만 있으면 무조건 성립하나요?",
    answer:
      "신체접촉이 있었다는 사실만으로 언제나 강제추행이 성립하는 것은 아닙니다. 접촉 부위와 방법, 폭행·협박 또는 유형력 행사, 행위의 경위와 의도, 당사자 관계, 당시 상황을 종합적으로 판단합니다. 대법원은 강제추행에서의 폭행·협박이 반드시 피해자의 항거를 곤란하게 할 정도에 이를 필요는 없다고 보고 있습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "접촉 전후 상황, 대화, CCTV·목격자, 당사자 관계와 즉시 대응",
  },
  {
    id: 14,
    category: "성범죄",
    question: "상대방이 동의했다고 생각했는데 성범죄로 신고됐습니다. 어떻게 해야 하나요?",
    answer:
      "동의 여부는 피의자의 주관적 생각만으로 결정되지 않으며 사건 당시의 말과 행동, 관계, 만남의 경위와 전후 정황을 함께 살핍니다. 문자·메신저, 통화내역, CCTV, 결제·이동 자료 등 원본을 보존해야 합니다. 불리해 보인다는 이유로 대화를 삭제하거나 편집하면 오히려 문제가 될 수 있습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "전체 대화 원본, 만남 경위, 이동·결제 기록, 사건 직후 연락",
  },
  {
    id: 15,
    category: "성범죄",
    question: "카카오톡이나 문자도 성범죄 증거가 되나요?",
    answer:
      "카카오톡·문자·SNS 메시지는 사건 전후의 관계와 의사표현을 판단하는 중요한 자료가 될 수 있습니다. 특정 문장 하나보다 전체 대화의 흐름, 작성 시점, 상대방과의 실제 관계, 다른 객관적 자료와의 일치 여부가 중요합니다. 캡처뿐 아니라 원본 기기와 대화 내보내기 자료도 보존하는 것이 좋습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "원본 기기, 전체 대화, 메타정보, 통화·CCTV·결제자료와의 일치",
  },
  {
    id: 16,
    category: "성범죄",
    question: "피해자와 합의하면 성범죄 처벌을 피할 수 있나요?",
    answer:
      "합의만으로 성범죄 사건이 반드시 종결되는 것은 아닙니다. 다만 피해 회복과 피해자의 처벌 의사는 범죄 유형과 사건 내용에 따라 처분이나 양형에서 고려될 수 있습니다. 피해자에게 직접 반복 연락하거나 압박하는 방식은 피하고, 의사를 존중하는 적절한 절차로 진행해야 합니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "적용 죄명, 피해 회복 방식, 연락 금지 필요성, 합의서·처벌불원서",
  },
  {
    id: 17,
    category: "성범죄",
    question: "동의 없이 사진이나 영상을 촬영하면 처벌될 수 있나요?",
    answer:
      "성적 욕망 또는 수치심을 유발할 수 있는 신체를 촬영대상자의 의사에 반하여 촬영하면 성폭력범죄의 처벌 등에 관한 특례법상 카메라등이용촬영죄가 문제될 수 있습니다. 촬영 당시 동의가 있었더라도 이후 상대방의 의사에 반해 유포·제공하면 별도 범죄가 성립할 수 있습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "촬영 대상·구도, 동의 범위, 저장·전송·유포 여부, 삭제 및 회수 상태",
  },
  {
    id: 18,
    category: "성범죄",
    question: "직장 내 신체접촉도 강제추행이 될 수 있나요?",
    answer:
      "직장에서 이루어진 신체접촉도 구체적인 상황에 따라 강제추행이 성립할 수 있습니다. 접촉 부위와 방법, 업무상 지위, 반복성, 당시 언행과 피해자의 반응 등을 종합적으로 판단합니다. 형사절차와 별개로 직장 내 성희롱 조사나 징계 절차가 함께 진행될 가능성도 있습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "CCTV·목격자, 사내 메신저, 출입기록, 인사조사 자료와 진술",
  },
  {
    id: 19,
    category: "성범죄",
    question: "술에 취해 기억이 없으면 성범죄 책임이 없어지나요?",
    answer:
      "단순히 술에 취해 기억이 나지 않는다는 사정만으로 형사책임이 없어지는 것은 아닙니다. 음주 경위와 정도, 사건 전후 행동, 대화와 영상, 귀가 과정 등 객관적 자료로 실제 상태를 확인합니다. 스스로 술을 마신 경우 심신장애 주장이 제한될 수 있으므로 섣불리 단정해서는 안 됩니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "음주량·시간, 결제내역, CCTV, 동행자, 귀가 및 사건 후 행동",
  },
  {
    id: 20,
    category: "성범죄",
    question: "성범죄로 유죄판결을 받으면 신상정보 등록도 되나요?",
    answer:
      "성범죄 유죄판결에는 형벌 외에 신상정보 등록, 취업제한, 수강·이수명령 등 보안처분이 함께 문제될 수 있습니다. 모든 사건에 동일하게 적용되는 것은 아니며 죄명, 선고형, 피해자 연령과 법원의 판단에 따라 달라집니다. 공소장 단계부터 부수처분 가능성까지 함께 검토해야 합니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "정확한 죄명, 피해자 연령, 구형·선고 내용, 취업 분야와 자격",
  },
  {
    id: 21,
    category: "성범죄",
    question: "성범죄 사건에서 무고로 맞고소할 수 있나요?",
    answer:
      "신고 내용이 사실과 다르다는 이유만으로 곧바로 무고죄가 성립하는 것은 아닙니다. 무고죄는 타인으로 하여금 형사처분 또는 징계처분 등을 받게 할 목적으로 허위 사실을 신고하는 경우에 성립합니다. 본 사건의 사실관계와 증거가 충분히 정리되기 전에 성급하게 맞고소하면 방어에 도움이 되지 않을 수 있습니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "신고 내용의 구체적 허위성, 상대방의 인식과 목적, 객관적 반박자료",
  },
  {
    id: 22,
    category: "성범죄",
    question: "디지털 성범죄 촬영물을 전달만 해도 처벌될 수 있나요?",
    answer:
      "불법촬영물 등을 직접 촬영하지 않았더라도 반포·판매·임대·제공하거나 소지·구입·저장·시청한 행위가 법률상 처벌 대상이 될 수 있습니다. 대상물의 성격, 취득 경위, 고의, 전송 범위와 반복성을 구체적으로 봅니다. 임의 삭제 전에는 수사 대응과 피해 확산 방지 방안을 함께 검토해야 합니다. 성범죄 사건은 진술과 디지털 자료의 맥락이 중요하고 2차 피해 방지도 필요합니다. 상대방에게 직접 연락하기 전에 법적 위험을 확인하고, 원본 자료를 훼손 없이 보존해 개별 검토해야 합니다.",
    points: "파일 취득 경위, 저장·시청·전송 기록, 대상물 성격, 유포 범위",
  },
  {
    id: 23,
    category: "사기·경제범죄",
    question: "돈을 빌리고 갚지 못하면 모두 사기죄가 되나요?",
    answer:
      "채무를 갚지 못했다는 결과만으로 바로 사기죄가 성립하는 것은 아닙니다. 돈을 빌릴 당시 변제 의사나 능력이 없었는지, 상대방을 속인 내용이 무엇인지, 그 말 때문에 돈이 지급됐는지를 판단합니다. 차용 경위, 당시 재산·수입, 사용처와 이후 변제 노력이 중요합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "차용증·대화, 당시 재산과 소득, 자금 사용처, 일부 변제와 연락 내역",
  },
  {
    id: 24,
    category: "사기·경제범죄",
    question: "투자금을 돌려주지 못하면 사기죄인가요?",
    answer:
      "투자 손실이나 사업 실패만으로 사기죄가 되는 것은 아닙니다. 투자 유치 당시 수익 구조, 원금 보장 약속, 중요 위험의 은폐, 자금 사용계획과 실제 사용처가 핵심입니다. 처음부터 허위 설명으로 투자금을 받은 것인지 단순한 경영상 실패인지 객관적 자료로 구분해야 합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "투자계약서·제안서, 수익·원금 약정, 계좌 흐름, 사업 진행 자료",
  },
  {
    id: 25,
    category: "사기·경제범죄",
    question: "중고거래 사기를 당하면 어떻게 대응해야 하나요?",
    answer:
      "판매자와의 대화, 게시글, 송금내역, 계좌번호·전화번호·배송정보를 먼저 보존하고 플랫폼 신고와 수사기관 고소를 검토할 수 있습니다. 지급정지 가능 여부는 거래 형태와 금융기관 판단에 따라 다르므로 신속히 문의해야 합니다. 동일 피해자가 있다면 관련 사건번호도 도움이 될 수 있습니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "게시글 원본, 전체 대화, 송금확인증, 상대 계정·전화·계좌정보",
  },
  {
    id: 26,
    category: "사기·경제범죄",
    question: "회사 돈을 개인적으로 사용하면 횡령죄가 되나요?",
    answer:
      "회사 자금을 보관·관리하는 사람이 권한 없이 개인 용도로 사용하면 업무상횡령죄가 문제될 수 있습니다. 회계상 가지급금으로 처리했다거나 나중에 반환했다는 사정만으로 당연히 책임이 없어지는 것은 아닙니다. 사용 권한, 이사회 승인, 용도와 반환 경위를 살핍니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "법인계좌 내역, 자금집행 권한, 이사회·주주총회 자료, 회계처리와 반환",
  },
  {
    id: 27,
    category: "사기·경제범죄",
    question: "동업자가 사업자금을 마음대로 쓰면 횡령인가요?",
    answer:
      "동업관계의 자금 사용이 횡령에 해당하는지는 자금의 소유·보관관계와 동업계약, 사용 권한을 확인해야 합니다. 공동사업 자금과 개인 자금이 섞여 있거나 정산 약정이 불분명하면 민사상 분쟁과 형사책임의 경계가 쟁점이 됩니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "동업계약, 출자·지분, 계좌관리 권한, 사용처와 정산 내역",
  },
  {
    id: 28,
    category: "사기·경제범죄",
    question: "배임죄는 어떤 경우에 성립하나요?",
    answer:
      "타인의 사무를 처리하는 사람이 임무에 위배되는 행위로 자신이나 제3자에게 재산상 이익을 주고 본인(위임인)에게 재산상 손해를 가한 경우 배임죄가 문제될 수 있습니다. 단순한 계약 위반만으로는 부족하며 타인의 사무를 처리하는 지위, 임무 위배와 손해를 구체적으로 검토해야 합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "업무 권한과 의무, 계약·내부규정, 이익 귀속, 회사 손해 산정자료",
  },
  {
    id: 29,
    category: "사기·경제범죄",
    question: "보이스피싱에 계좌를 빌려주면 처벌받나요?",
    answer:
      "통장·체크카드·접근매체를 타인에게 양도하거나 대여하면 전자금융거래법 위반이 문제될 수 있고, 범죄임을 알면서 가담했다면 사기 방조 등도 검토될 수 있습니다. 고액 대출이나 수수료를 미끼로 한 요구였다 해도 경위와 인식 정도를 조사합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "메신저·통화, 접근매체 전달 경위, 입출금 내역, 대가 수수 여부",
  },
  {
    id: 30,
    category: "사기·경제범죄",
    question: "보이스피싱 현금 전달책도 사기죄로 처벌되나요?",
    answer:
      "현금 전달·수거 역할만 했더라도 범죄임을 알았거나 미필적으로 인식했다고 인정되면 사기죄의 공동정범 또는 방조범으로 처벌될 수 있습니다. 구인 경위, 비정상적인 업무 지시, 수당, 반복 횟수와 전달 방식 등을 통해 인식 여부를 판단합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "구인광고, 업무지시 대화, 이동·전달 기록, 수당과 반복 횟수",
  },
  {
    id: 31,
    category: "사기·경제범죄",
    question: "사기 피해금은 형사고소만 하면 돌려받을 수 있나요?",
    answer:
      "형사고소는 가해자의 처벌을 구하는 절차이므로 피해금이 자동으로 반환되는 것은 아닙니다. 수사·재판 중 합의, 배상명령, 별도의 민사소송과 가압류 등을 검토할 수 있습니다. 상대방 재산이 빠르게 처분될 우려가 있다면 보전처분의 실익과 비용을 함께 판단해야 합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "피해액 산정, 송금·계약자료, 상대 재산 단서, 배상명령 가능 범죄",
  },
  {
    id: 32,
    category: "사기·경제범죄",
    question: "업무상횡령 혐의로 회사 내부감사를 받으면 어떻게 해야 하나요?",
    answer:
      "내부감사 진술과 제출자료는 이후 형사절차에서 사용될 수 있으므로 사실관계와 자금 흐름을 먼저 정리해야 합니다. 회사 자료를 임의 삭제하거나 반출하면 별도 문제가 생길 수 있습니다. 업무 권한, 관행, 결재 과정과 개인 사용 여부를 객관적인 자료로 설명하는 것이 중요합니다. 경제범죄는 민사상 채무불이행과 형사책임을 구별해야 합니다. 계약 당시의 설명과 자금 흐름, 권한 관계를 시간순으로 정리하고 원본 회계·금융자료를 보존해 개별 검토해야 합니다.",
    points: "감사 통지, 결재선·내부규정, 회계자료, 이메일, 반환 또는 정산 내역",
  },
  {
    id: 33,
    category: "음주·교통",
    question: "음주운전으로 적발되면 형사처벌과 면허처분을 모두 받나요?",
    answer:
      "음주운전은 형사처벌과 별도로 운전면허 정지·취소 등 행정처분이 문제될 수 있습니다. 혈중알코올농도, 과거 전력, 사고 여부와 측정 과정에 따라 달라집니다. 형사사건 대응뿐 아니라 면허처분에 대한 이의신청이나 행정심판 가능성과 기한도 함께 확인해야 합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "측정수치·시간, 운전거리, 사고·전력, 면허처분 통지일",
  },
  {
    id: 34,
    category: "음주·교통",
    question: "경찰의 음주측정을 거부하면 어떻게 되나요?",
    answer:
      "정당한 이유 없이 경찰공무원의 적법한 음주측정 요구에 응하지 않으면 음주측정거부죄가 문제될 수 있습니다. 실제 운전 여부, 음주운전을 의심할 상당한 이유, 반복된 측정 요구와 거부 의사가 명확했는지 등을 확인합니다. 거부 자체에 별도의 면허처분도 따를 수 있습니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "측정 요구 횟수·간격, 고지 내용, 바디캠·영상, 거부 경위와 건강상 사유",
  },
  {
    id: 35,
    category: "음주·교통",
    question: "음주운전 초범이면 벌금으로 끝나나요?",
    answer:
      "초범이라는 이유만으로 반드시 벌금형으로 끝난다고 단정할 수 없습니다. 혈중알코올농도, 운전거리와 경위, 사고와 피해, 범행 후 정황이 함께 고려됩니다. 인명피해가 발생하면 단순 음주운전 외에 위험운전치상 등 추가 혐의가 문제될 수 있습니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "측정수치, 운전거리·목적, 사고 피해, 보험·합의와 재범방지 자료",
  },
  {
    id: 36,
    category: "음주·교통",
    question: "숙취운전도 음주운전에 해당하나요?",
    answer:
      "전날 마신 술이 완전히 분해되지 않아 운전 당시 혈중알코올농도가 법정 기준 이상이면 숙취 상태라도 음주운전이 성립할 수 있습니다. 잠을 잤거나 술을 마신 뒤 시간이 지났다는 이유만으로 면책되지 않습니다. 측정시각과 최종 음주시각, 운전시각을 정확히 확인해야 합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "최종 음주·운전·측정 시각, 음주량, 채혈 여부, 위드마크 적용 쟁점",
  },
  {
    id: 37,
    category: "음주·교통",
    question: "교통사고 피해자와 합의하면 형사처벌을 받지 않나요?",
    answer:
      "사고 유형, 피해 정도, 종합보험 가입과 중대한 법규 위반 여부에 따라 형사책임이 달라집니다. 일부 사고는 합의나 보험 가입이 처벌 여부에 영향을 주지만, 사망·중상해 또는 법정 중과실 사고는 합의와 별도로 형사절차가 진행될 수 있습니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "진단기간·상해 정도, 보험 가입, 중과실 여부, 합의·처벌불원 의사",
  },
  {
    id: 38,
    category: "음주·교통",
    question: "사고가 난 줄 모르고 현장을 떠나도 뺑소니가 되나요?",
    answer:
      "현장을 떠났다는 사실만으로 일률적으로 도주(뺑소니) 범죄가 성립하는 것은 아닙니다. 사람이 다쳤는지, 운전자가 사고와 피해를 인식했는지, 구호 등 필요한 조치 없이 이탈했는지를 판단합니다. 충격 정도와 사고 후 행동, 신고 여부, 영상과 피해 상태가 중요합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "블랙박스·CCTV, 충격 정도, 정차·신고·구호 여부, 피해자 상태",
  },
  {
    id: 39,
    category: "음주·교통",
    question: "종합보험에 가입돼 있으면 교통사고 형사처벌을 피할 수 있나요?",
    answer:
      "종합보험 가입이 모든 사고의 형사책임을 없애는 것은 아닙니다. 교통사고처리 특례법상 보험 가입이 공소제한에 영향을 주는 경우가 있지만, 사망·중상해 사고나 법에서 정한 중대한 법규 위반은 예외가 될 수 있습니다. 사고 유형을 먼저 정확히 분류해야 합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "보험 보장 범위, 피해 정도, 신호위반·중앙선침범 등 중과실 여부",
  },
  {
    id: 40,
    category: "음주·교통",
    question: "무면허운전 중 사고가 나면 어떻게 되나요?",
    answer:
      "무면허운전 자체가 형사처벌 대상이며 사고로 사람이 다치거나 재산피해가 발생하면 추가 책임이 문제됩니다. 보험의 보상 여부와 구상관계도 일반 사고와 다르게 전개될 수 있습니다. 면허 취소·정지 기간 중 운전인지, 적법한 면허를 취득한 적이 없는지도 확인합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "면허 상태, 사고 경위와 피해, 보험관계, 동승자·차량소유자 관여",
  },
  {
    id: 41,
    category: "음주·교통",
    question: "교통사고 후 현장에서 반드시 해야 할 조치는 무엇인가요?",
    answer:
      "교통사고가 발생하면 즉시 정차해 사상자를 구호하고 필요한 조치를 해야 하며, 사고 내용에 따라 경찰 신고도 필요합니다. 안전조치 없이 현장을 떠나면 도주나 사고후미조치가 문제될 수 있습니다. 자신의 안전을 확보하면서 119·112 신고, 피해 확인과 현장 보존을 우선해야 합니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "정차·구호·신고 시각, 연락처 제공, 현장사진·영상, 목격자",
  },
  {
    id: 42,
    category: "음주·교통",
    question: "음주운전 면허취소에 행정심판을 청구할 수 있나요?",
    answer:
      "면허취소 처분에 불복하려면 행정심판이나 행정소송을 검토할 수 있지만, 청구했다고 처분의 효력이 자동으로 정지되는 것은 아닙니다. 법정 제기기간을 지켜야 하며, 측정과 처분의 위법성, 운전 경위, 생계 필요성 등은 구제 가능성을 판단하는 요소가 됩니다. 교통사건은 형사책임, 면허 행정처분, 민사상 손해배상이 함께 진행될 수 있습니다. 블랙박스와 현장자료를 신속히 보존하고 각 절차의 불복·제출 기한을 놓치지 않아야 합니다.",
    points: "처분서 수령일, 측정 절차, 운전 전력, 생계형 운전 증빙",
  },
  {
    id: 43,
    category: "이혼·가사",
    question: "배우자가 이혼을 거부해도 이혼할 수 있나요?",
    answer:
      "배우자가 동의하지 않아도 민법상 재판상 이혼사유가 인정되면 이혼소송을 제기할 수 있습니다. 부정행위, 악의의 유기, 심히 부당한 대우, 혼인을 계속하기 어려운 중대한 사유 등이 쟁점이 됩니다. 법원은 파탄 원인과 정도, 별거기간, 회복 가능성을 종합적으로 봅니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "혼인 경과, 파탄 원인, 별거기간, 대화·진단·신고 등 객관자료",
  },
  {
    id: 44,
    category: "이혼·가사",
    question: "별거를 오래 하면 자동으로 이혼이 되나요?",
    answer:
      "별거기간이 길다는 이유만으로 혼인이 자동 해소되지는 않습니다. 협의이혼 절차를 마치거나 법원의 이혼판결이 확정돼야 합니다. 다만 장기간 별거는 혼인관계 파탄과 회복 가능성을 판단하는 중요한 사정이 될 수 있으며, 별거의 원인과 생활비·자녀 양육 상황도 함께 살핍니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "별거 시작일·원인, 생활비 지급, 자녀 양육, 연락과 관계 회복 노력",
  },
  {
    id: 45,
    category: "이혼·가사",
    question: "이혼하면 재산을 무조건 절반씩 나누나요?",
    answer:
      "이혼 재산분할이 항상 50대 50으로 정해지는 것은 아닙니다. 법원은 혼인기간, 재산의 취득 경위, 각 배우자의 형성·유지 기여, 가사와 육아 기여 등을 종합적으로 고려합니다. 명의만으로 결정되지 않으며 부동산·예금·주식·보험·퇴직급여·채무를 함께 검토합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "재산목록, 취득자금, 혼인기간, 소득·가사·육아 기여와 채무",
  },
  {
    id: 46,
    category: "이혼·가사",
    question: "결혼 전 재산이나 상속재산도 재산분할 대상인가요?",
    answer:
      "혼인 전 보유재산이나 혼인 중 상속·증여받은 재산은 일반적으로 특유재산으로 보아 분할 대상에서 제외되는 것이 원칙입니다. 다만 다른 배우자가 그 재산의 유지, 감소 방지 또는 가치 증가에 실질적으로 기여한 경우에는 재산분할에서 고려될 수 있습니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "취득·상속·증여 시점, 자금출처, 관리·대출상환, 가치변동과 기여",
  },
  {
    id: 47,
    category: "이혼·가사",
    question: "배우자의 외도가 확인되면 위자료를 받을 수 있나요?",
    answer:
      "배우자의 부정행위가 혼인 파탄의 원인이 됐다면 배우자에게 이혼과 위자료를 청구할 수 있습니다. 사안에 따라 부정행위 상대방에 대한 손해배상도 검토됩니다. 다만 이미 혼인이 실질적으로 파탄된 뒤의 관계인지, 상대방이 혼인 사실을 알았는지 등이 쟁점이 될 수 있습니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "부정행위 증거, 혼인 파탄 시점, 상간자의 혼인 인식, 정신적 손해",
  },
  {
    id: 48,
    category: "이혼·가사",
    question: "상간자에게도 위자료를 청구할 수 있나요?",
    answer:
      "배우자와 부정행위를 한 제3자가 혼인 사실을 알면서 부부공동생활을 침해했다면 손해배상책임이 인정될 수 있습니다. 그러나 부정행위 전에 혼인이 이미 실질적으로 파탄된 경우 등에는 책임이 부정될 수 있습니다. 무단 계정 접속이나 불법 위치추적 등 위법한 방법으로 수집한 증거는 피해야 합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "혼인 인식, 부정행위 내용·기간, 파탄 시점, 적법하게 확보한 증거",
  },
  {
    id: 49,
    category: "이혼·가사",
    question: "이혼 재산분할은 언제까지 청구해야 하나요?",
    answer:
      "재산분할청구권은 이혼한 날부터 2년이 지나면 소멸합니다. 협의이혼은 이혼신고일, 재판상 이혼은 판결 확정일 등 기준일을 정확히 확인해야 합니다. 재산이 뒤늦게 발견되거나 협의가 진행 중이더라도 기간 문제가 생길 수 있으므로 미리 청구 여부를 검토하는 것이 안전합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "이혼 성립일, 기존 재산분할 합의, 누락재산, 소송·조정 신청일",
  },
  {
    id: 50,
    category: "이혼·가사",
    question: "배우자가 재산을 숨기면 어떻게 찾을 수 있나요?",
    answer:
      "재산분할 소송에서는 법원을 통한 금융거래정보 제출명령, 사실조회, 재산명시 등 절차를 활용할 수 있습니다. 의심만으로 모든 재산을 확인할 수 있는 것은 아니므로 금융기관, 부동산, 보험, 주식 등 구체적인 단서를 정리해야 합니다. 무단 계정 접속 등 위법한 방법은 피해야 합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "부동산·계좌·보험·법인 지분 단서, 최근 처분, 세금·대출 자료",
  },
  {
    id: 51,
    category: "이혼·가사",
    question: "전업주부도 재산분할을 받을 수 있나요?",
    answer:
      "전업주부도 가사와 육아를 통해 공동재산의 형성·유지에 기여했다면 재산분할을 받을 수 있습니다. 경제활동을 하지 않았다는 이유만으로 기여가 부정되는 것은 아닙니다. 혼인기간, 가사·양육 부담, 배우자의 경제활동 지원, 특유재산 관리 등을 종합적으로 판단합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "혼인기간, 자녀 양육, 가사분담, 배우자 사업·재산 관리 기여",
  },
  {
    id: 52,
    category: "이혼·가사",
    question: "퇴직금과 국민연금도 재산분할 대상인가요?",
    answer:
      "혼인 중 형성된 퇴직급여나 장래 퇴직금은 구체적 사정에 따라 재산분할에서 고려될 수 있습니다. 국민연금은 재산분할과 별도로 국민연금법상 분할연금 요건을 검토해야 합니다. 가입기간과 혼인기간, 실제 혼인관계가 없었던 기간 등 자료가 중요합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "재직·퇴직급여 예상액, 국민연금 가입기간, 혼인·별거기간",
  },
  {
    id: 53,
    category: "이혼·가사",
    question: "이혼할 때 양육권과 친권은 어떻게 결정되나요?",
    answer:
      "법원은 부모 중 누구에게 유리한지보다 미성년 자녀의 복리를 가장 중요한 기준으로 봅니다. 자녀의 연령과 의사, 기존 양육상황, 부모와의 친밀도, 양육환경과 계획, 부모의 양육 의사와 능력을 종합합니다. 양육자·친권자와 함께 양육비와 면접교섭도 정해야 합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "현재 주양육자, 자녀 생활·의사, 주거·돌봄 계획, 부모의 협력 가능성",
  },
  {
    id: 54,
    category: "이혼·가사",
    question: "양육비는 얼마까지 받을 수 있나요?",
    answer:
      "양육비는 정액으로 법에 정해진 것이 아니라 부모의 소득과 재산, 자녀의 나이와 수, 거주지역, 교육·의료비 등 구체적 사정을 고려해 정합니다. 법원의 양육비 산정기준표는 참고자료이며 개별 사건에 따라 증감될 수 있습니다. 소득자료와 실제 지출을 함께 준비해야 합니다. 가사사건은 가족관계와 재산·자녀 사정에 따라 결론이 크게 달라집니다. 감정적 대응이나 위법한 증거수집을 피하고, 기준일과 법정 청구기간을 확인해 개별적으로 판단해야 합니다.",
    points: "부모 소득·재산, 자녀 나이·수, 교육·의료비, 기존 양육비 부담",
  },
  {
    id: 55,
    category: "개인회생",
    question: "개인회생은 누가 신청할 수 있나요?",
    answer:
      "채무를 정상적으로 갚기 어렵거나 그 우려가 있고 계속적·반복적인 수입을 얻을 가능성이 있는 개인채무자가 신청할 수 있습니다. 급여소득자뿐 아니라 자영업자·프리랜서도 가능합니다. 직업 명칭보다 변제계획을 수행할 지속적 수입과 채무한도 충족 여부가 중요합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "채무 총액·종류, 월평균 소득, 재산, 부양가족과 최근 채무 증가",
  },
  {
    id: 56,
    category: "개인회생",
    question: "개인회생의 채무한도는 얼마인가요?",
    answer:
      "현행 채무자회생법상 담보부 개인회생채권은 15억 원 이하, 그 밖의 개인회생채권은 10억 원 이하인 개인채무자가 대상이 될 수 있습니다(법 개정시 한도가 변경될 수 있으므로 신청시점의 법령을 확인해야 합니다). 담보부와 무담보 채무를 구분해 계산해야 하며, 한도를 넘는다면 일반회생 등 다른 절차를 검토할 수 있습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "담보·무담보 채권 구분, 원금·이자, 보증채무, 별제권과 최근 잔액증명",
  },
  {
    id: 57,
    category: "개인회생",
    question: "빚 1억이면 개인회생으로 얼마를 갚아야 하나요?",
    answer:
      "채무가 1억 원이라는 사실만으로 변제총액을 정할 수 없습니다. 일반적으로 월 소득에서 법원이 인정하는 생계비 등을 뺀 가용소득, 보유재산의 청산가치, 채무 성격과 변제기간을 함께 봅니다. 재산이 많거나 인정 생계비가 줄면 변제금이 높아질 수 있습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "세후 소득, 부양가족, 주거비·의료비, 예금·보험·차량·부동산과 채무",
  },
  {
    id: 58,
    category: "개인회생",
    question: "월급 300만 원이면 개인회생 변제금은 얼마인가요?",
    answer:
      "월급 300만 원이라도 부양가족과 인정 생계비, 추가 생계비, 재산과 채무에 따라 월 변제금이 달라집니다. 단순 계산은 월 소득에서 인정 생계비를 뺀 금액을 출발점으로 보지만, 청산가치 보장과 가용소득 전부투입 원칙 등을 함께 충족해야 합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "최근 급여명세·원천징수, 가족관계, 주거·의료비, 재산과 예상 퇴직금",
  },
  {
    id: 59,
    category: "개인회생",
    question: "주식이나 코인 투자로 생긴 빚도 개인회생이 가능한가요?",
    answer:
      "주식·가상자산 투자채무라는 이유만으로 신청이 금지되지는 않습니다. 다만 법원은 투자 규모와 시기, 최근 거래내역, 재산 처분과 채무 증가 경위를 자세히 확인할 수 있습니다. 신청 직전 과도한 투자나 은닉이 의심되면 추가 소명 또는 변제계획에 영향을 줄 수 있습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "전체 거래내역, 입출금·대출 흐름, 보유자산, 손실과 처분 경위",
  },
  {
    id: 60,
    category: "개인회생",
    question: "도박으로 생긴 빚도 개인회생이 가능한가요?",
    answer:
      "도박이나 과소비 채무가 있다는 이유만으로 개인회생 신청 자체가 당연히 불가능한 것은 아닙니다. 다만 도박 규모와 시기, 최근 채무 증가, 소득과 재산을 엄격히 심사하고 추가 자료를 요구할 수 있습니다. 거래를 숨기거나 허위로 작성하면 기각 등 불이익이 생길 수 있습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "도박 시기·규모, 채무 증가 경위, 소득·재산, 재발방지 자료",
  },
  {
    id: 61,
    category: "개인회생",
    question: "집이나 자동차가 있어도 개인회생을 신청할 수 있나요?",
    answer:
      "부동산이나 자동차 보유만으로 신청이 배제되지는 않습니다. 다만 재산의 순가치가 청산가치에 반영돼 최소 변제총액에 영향을 줄 수 있고, 담보대출이나 자동차 할부가 있다면 유지 가능성을 별도로 검토해야 합니다. 모든 재산과 채무를 정확히 신고해야 합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "시가, 담보잔액, 차량·보험·예금, 임차보증금, 유지비와 소득",
  },
  {
    id: 62,
    category: "개인회생",
    question: "개인회생을 신청하면 추심이 바로 중단되나요?",
    answer:
      "신청서를 접수했다는 사실만으로 모든 추심과 강제집행이 자동 중단되는 것은 아닙니다. 필요한 경우 금지명령·중지명령을 함께 신청해 변제 요구나 강제집행에 대응할 수 있습니다. 이미 급여·계좌 압류가 진행됐다면 압류 단계와 해제 가능성을 별도로 확인해야 합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "추심기관, 소송·지급명령, 급여·계좌 압류, 금지·중지명령 신청 여부",
  },
  {
    id: 63,
    category: "개인회생",
    question: "개인회생 변제기간은 몇 년인가요?",
    answer:
      "변제기간은 원칙적으로 변제개시일부터 3년을 초과하지 않으며, 법률상 특별한 사정이 있으면 5년 이내로 정해질 수 있습니다. 월 변제금은 채무를 단순히 36개월로 나눈 금액이 아니라 소득, 생계비, 재산의 청산가치와 채무 종류를 반영해 산정합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "개시 예정일, 가용소득, 청산가치, 우선권 채권과 미납 변제 가능성",
  },
  {
    id: 64,
    category: "개인회생",
    question: "세금이 밀려 있어도 개인회생을 신청할 수 있나요?",
    answer:
      "세금 체납이 있어도 신청은 가능하지만 조세채권은 일반 신용채무와 취급이 다릅니다. 면책결정 후에도 법에서 정한 조세청구권은 면책되지 않으며, 변제계획에서 우선권과 납부 가능성을 검토해야 합니다. 체납이 크면 전체 계획의 수행 가능성에 큰 영향을 줍니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "국세·지방세 종류와 체납액, 압류, 납부기한, 일반채무와 월 소득",
  },
  {
    id: 65,
    category: "개인회생",
    question: "개인회생이 끝나면 남은 빚은 모두 없어지나요?",
    answer:
      "변제계획을 수행하고 면책결정이 확정되면 원칙적으로 미변제 개인회생채권의 책임이 면제됩니다. 그러나 조세, 벌금·과료·추징금·과태료, 고의로 가한 불법행위에 기한 손해배상채무, 임금·퇴직금, 양육비·부양료 등은 면책되지 않을 수 있습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "채권별 발생 원인, 조세·벌금, 고의 불법행위, 임금·양육비 포함 여부",
  },
  {
    id: 66,
    category: "개인회생",
    question: "개인회생을 하면 신용카드를 사용할 수 있나요?",
    answer:
      "개인회생 신청 전후에는 카드 이용이 정지되거나 신규 발급이 어려워지는 것이 일반적입니다. 카드사 채무가 포함되면 상계나 결제계좌 문제도 생길 수 있습니다. 면책 후 신용회복과 카드 발급 시점은 신용정보와 금융회사 심사에 따라 달라져 즉시 보장되지는 않습니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "카드채무·결제일, 결제계좌, 자동이체, 체크카드와 생활비 계좌",
  },
  {
    id: 67,
    category: "개인회생",
    question: "개인회생을 하면 회사에서 알게 되나요?",
    answer:
      "법원이 신청 사실을 직장에 자동 통보하는 절차는 일반적이지 않습니다. 다만 급여 관련 자료 제출, 급여압류, 채권자 관계 또는 회사가 채권자인 경우 간접적으로 알려질 가능성이 있습니다. 공무원·특정 자격직 등은 개별 법령이나 내부 규정을 별도로 확인해야 합니다. 법원별 실무와 신청인의 소득·재산·가족관계에 따라 요구자료와 변제계획이 달라질 수 있습니다. 채무와 재산을 빠짐없이 신고하고 신청 직전의 거래를 포함해 자료를 정확히 준비해야 합니다.",
    points: "급여압류 여부, 재직·소득 증빙 방식, 회사가 채권자인지, 직종 규정",
  },
  {
    id: 68,
    category: "법인회생",
    question: "법인회생과 법인파산은 무엇이 다른가요?",
    answer:
      "법인회생은 사업을 계속하며 채무를 조정해 정상화를 추진하는 절차이고, 법인파산은 재산을 환가해 채권자에게 배당하고 법인을 정리하는 절차입니다. 영업력과 계속기업가치, 향후 현금흐름이 있다면 회생을, 청산이 더 합리적이면 파산을 검토합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "계속기업가치·청산가치, 매출·영업이익, 자산과 채무, 자금수지",
  },
  {
    id: 69,
    category: "법인회생",
    question: "회사가 어느 정도 어려워졌을 때 법인회생을 신청해야 하나요?",
    answer:
      "완전히 지급불능이 된 뒤에만 신청할 수 있는 것은 아닙니다. 만기 채무를 정상적으로 갚기 어렵거나 과도한 금융비용으로 영업이 흔들린다면 검토할 수 있습니다. 핵심 자산 압류나 거래 단절 전에 매출, 현금흐름과 향후 사업 전망을 분석하는 것이 중요합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "13주 자금수지, 연체 예정, 핵심 거래처, 담보·압류와 수주 전망",
  },
  {
    id: 70,
    category: "법인회생",
    question: "법인회생은 대표이사만 신청할 수 있나요?",
    answer:
      "회사 자체가 회생절차 개시를 신청할 수 있고, 법률상 일정 요건을 갖춘 채권자나 주주·지분권자도 신청할 수 있습니다. 신청권자는 회사 형태와 자본·채권 관계에 따라 달라집니다. 이사회 결의나 내부 의사결정이 필요한지도 정관과 회사법 관계를 확인해야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "회사 형태, 신청인 지위, 채권·지분 규모, 이사회·주주총회 자료",
  },
  {
    id: 71,
    category: "법인회생",
    question: "법인회생을 신청하면 대표이사가 경영권을 잃나요?",
    answer:
      "신청만으로 기존 대표가 반드시 경영에서 배제되는 것은 아닙니다. 특별한 사정이 없으면 기존 경영자가 관리인으로 선임되거나 관리인으로 간주되어 경영에 참여하는 구조가 활용됩니다. 다만 재산 유용·은닉이나 중대한 부실경영 책임 등이 있으면 제3자 관리인이 선임될 수 있습니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "부실 원인, 자금 유용 여부, 회계 투명성, 경영 정상화 계획과 협조",
  },
  {
    id: 72,
    category: "법인회생",
    question: "법인회생을 신청하면 압류나 강제집행을 막을 수 있나요?",
    answer:
      "신청만으로 모든 집행이 자동 중단되지는 않지만 법원은 개시 전 중지명령이나 포괄적 금지명령 등을 내릴 수 있습니다. 절차가 개시되면 회생채권·회생담보권에 기한 새로운 집행이 제한되고 진행 중인 일정한 집행도 중지될 수 있습니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "압류·경매 대상과 단계, 채권 종류, 신청할 보전처분, 핵심자산 가치",
  },
  {
    id: 73,
    category: "법인회생",
    question: "법인회생 중에도 영업을 계속할 수 있나요?",
    answer:
      "법인회생은 기본적으로 사업을 계속하면서 기업을 정상화하는 절차입니다. 다만 개시 후 회사 재산과 업무는 관리인의 관리 아래 놓이고, 중요한 자산 처분·차입·담보 제공 등에는 법원 허가가 필요할 수 있습니다. 정상 영업자금과 거래처 관리계획을 미리 마련해야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "월별 자금수지, 필수 지출, 주요 계약, 허가가 필요한 행위와 거래처",
  },
  {
    id: 74,
    category: "법인회생",
    question: "채권자가 반대해도 법인회생이 가능한가요?",
    answer:
      "신청과 개시 단계에서 모든 채권자의 동의가 필요한 것은 아닙니다. 다만 회생계획안 가결과 인가 과정에서는 관계인집회 등에서 법정 동의 요건이 중요합니다. 현실적인 변제율과 사업계획을 제시하고 주요 채권자와 소통하는 것이 절차 성공 가능성에 영향을 줍니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "채권자 구성·의결권, 담보권, 예상 변제율, 사업계획과 협상 경과",
  },
  {
    id: 75,
    category: "법인회생",
    question: "법인회생을 하면 대표자의 연대보증채무도 없어지나요?",
    answer:
      "법인채무와 대표 개인의 연대보증채무는 별개입니다. 회사의 채무가 감면되거나 변제기간이 조정돼도 대표의 보증채무가 당연히 없어지지는 않습니다. 보증채무가 과도하다면 대표 개인의 개인회생·일반회생·파산 등 절차를 법인회생과 함께 검토할 수 있습니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "보증계약과 잔액, 담보, 대표의 소득·재산, 법인채무 조정 예상액",
  },
  {
    id: 76,
    category: "법인회생",
    question: "법인회생 중에도 회사 매각이나 M&A가 가능한가요?",
    answer:
      "회생절차 중에도 기업 정상화와 채권자 변제율 향상을 위해 M&A를 활용할 수 있습니다. 외부 투자 유치, 회사 또는 사업부 매각 등 방식이 가능하며 법원 허가와 절차 통제가 따릅니다. 사업가치, 인수희망자와 자금조달 가능성을 객관적으로 검토해야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "기업가치, 매각 범위, 잠재 인수자, 고용·계약 승계, 법원 일정",
  },
  {
    id: 77,
    category: "법인회생",
    question: "법인회생에 실패하면 바로 법인파산이 되나요?",
    answer:
      "회생 실패가 모든 경우 즉시·자동 파산을 뜻하지는 않습니다. 회생계획안이 가결되지 않거나 회생 가능성이 없다고 판단되면 회생절차가 폐지될 수 있고, 이후 파산원인이 인정되면 법률상 요건에 따라 파산이 선고될 수 있습니다. 신청 전 회생 가능성을 현실적으로 분석해야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "계속기업가치, 청산가치, 계획안 가결 가능성, 파산원인과 자산 현황",
  },
  {
    id: 78,
    category: "법인회생",
    question: "법인회생을 신청하면 거래처가 알게 되나요?",
    answer:
      "회생사건은 법원 절차로 진행되고 채권자에게 통지·공고가 이뤄지므로 주요 거래처가 채권자라면 알게 될 가능성이 큽니다. 계약상 통지의무나 기한이익상실 조항도 확인해야 합니다. 거래 중단을 줄이려면 납품·결제계획과 설명자료를 사전에 준비하는 것이 좋습니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "채권자목록, 주요 계약의 통지·해지 조항, 발주·납품과 결제계획",
  },
  {
    id: 79,
    category: "법인회생",
    question: "법인회생 중 직원 급여는 지급할 수 있나요?",
    answer:
      "회생 중에도 정상 영업에 필요한 직원 급여 지급은 중요합니다. 임금·퇴직금 채권은 발생 시기와 성격에 따라 공익채권 또는 회생채권 등 취급이 달라질 수 있으며, 지급에는 법원 허가가 필요한 경우가 있습니다. 체불 현황과 향후 인건비 자금계획을 정확히 세워야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "급여·퇴직금 발생 시기, 체불액, 직원 수, 월 인건비와 허가 필요성",
  },
  {
    id: 80,
    category: "법인회생",
    question: "법인회생 신청 비용과 기간은 얼마나 걸리나요?",
    answer:
      "비용과 기간은 법원의 예납명령, 조사위원 선임, 회사 규모와 자산·채무, 채권자 수, 회계자료 상태와 M&A 여부에 따라 크게 달라집니다. 정액으로 단정하기 어렵고, 신청 전 법원 비용과 전문가 비용, 절차 중 운전자금을 구분해 예산을 세워야 합니다. 법인회생은 법률뿐 아니라 회계와 자금계획이 함께 맞아야 합니다. 핵심 거래와 자산을 보전하면서 정확한 회계자료, 단기 자금수지와 현실적인 사업계획을 준비해 개별 검토해야 합니다.",
    points: "자산·부채 규모, 채권자 수, 회계자료, 조사위원·M&A 여부, 운전자금",
  },
];